export default __webpack_public_path__ + "static/muli-v20-latin-700-d5233c9504ed8bee51a09330d616124b.woff";